import { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQ = [
  {
    q: "Qual o prazo de entrega?",
    a: "Os produtos The Quick Brownie são entregues em até 5 dias úteis.",
  },
  {
    q: "Como armazenar?",
    a: "Na geladeira (-5 a 5 °C) por 30 dias.",
  },
  {
    q: "Qual adoçante é utilizado nos produtos?",
    a: "Utilizamos Eritritol na massa do Brownie (índice glicêmico zero).",
  },
  {
    q: "Sou celíaco, posso consumir os Brownies?",
    a: "Os brownies da The Quick Brownie não contêm glúten, pois não usamos trigo. Usamos farinha de arroz e aveia sem glúten — seguros para quem é celíaco.",
  },
  {
    q: "Sou intolerante à lactose, posso consumir os Brownies?",
    a: "Os brownies da The Quick Brownie são sem lactose, pois não usamos manteiga na receita e nem no chocolate — seguros para quem é intolerante à lactose.",
  },
];

export default function Faq() {
  const [open, setOpen] = useState(null);

  return (
    <section id="faq" data-testid="faq-section" className="border-t border-black">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-20 md:py-28">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.2em]">FAQ</p>
            <h2 className="font-display text-4xl md:text-6xl mt-6 leading-[0.95] tracking-[-0.02em]">
              Perguntas<br />frequentes.
            </h2>
            <p className="mt-6 text-base max-w-xs">
              Não achou o que procurava? Fale com a gente pelo WhatsApp ou Instagram —
              respondemos rápido.
            </p>
          </div>

          <ul className="md:col-span-8 border-t border-black">
            {FAQ.map((item, i) => {
              const isOpen = open === i;
              return (
                <li key={i} className="border-b border-black">
                  <button
                    type="button"
                    data-testid={`faq-toggle-${i}`}
                    onClick={() => setOpen(isOpen ? null : i)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-6 py-6 md:py-8 text-left group"
                  >
                    <span className="font-display text-xl md:text-3xl tracking-[-0.01em] pr-4">
                      {item.q}
                    </span>
                    <span
                      aria-hidden="true"
                      className="shrink-0 w-10 h-10 md:w-12 md:h-12 border border-black flex items-center justify-center transition-colors group-hover:bg-black group-hover:text-white"
                    >
                      {isOpen ? <Minus size={18} /> : <Plus size={18} />}
                    </span>
                  </button>
                  <div
                    data-testid={`faq-answer-${i}`}
                    className={`grid transition-[grid-template-rows] duration-300 ease-out ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}
                  >
                    <div className="overflow-hidden">
                      <p className="pb-6 md:pb-8 pr-14 text-base leading-relaxed max-w-2xl">
                        {item.a}
                      </p>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}
